import { render, staticRenderFns } from "./SwiperRedPagination.vue?vue&type=template&id=1747a2cb&"
import script from "./SwiperRedPagination.vue?vue&type=script&lang=js&"
export * from "./SwiperRedPagination.vue?vue&type=script&lang=js&"
import style0 from "./SwiperRedPagination.vue?vue&type=style&index=0&id=1747a2cb&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1747a2cb')) {
      api.createRecord('1747a2cb', component.options)
    } else {
      api.reload('1747a2cb', component.options)
    }
    module.hot.accept("./SwiperRedPagination.vue?vue&type=template&id=1747a2cb&", function () {
      api.rerender('1747a2cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/SwiperRedPagination.vue"
export default component.exports